import { useEffect, useState } from "react";
import api from "@/lib/api";

let cache = null;

// Real user count from the server (grows by itself). `label` is "" until loaded or if it fails.
export default function useUserCount() {
    const [s, setS] = useState(cache || { label: "", initials: [] });
    useEffect(() => {
        if (cache) return;
        api.get("/public/stats").then((r) => { cache = r.data; setS(r.data); }).catch(() => {});
    }, []);
    return s;
}
